import { PipeTransform, Pipe } from '@angular/core';

@Pipe({
    name: 'mainMenuItems',
    pure: false
})
export class PipeMainMenuItems implements PipeTransform {
    transform(items: any[], arr : any, main : any = null): any {
        let narr = [];

        arr.map(group=> {
          if(typeof items[group] !='undefined')
            items[group].map(item => narr.push(item));
        });
    
        if(main === null)
          return narr;
    
        return narr.filter(item => (main == true && item?.params?.main == true) || ( main== false && !item?.params?.main));
    }
}